import React, {Component} from 'react';

class HeaderRow extends Component {
  getHeaderStyle() {
    return {
      width: '100%',
      background: '#6060601A',
      boxShadow: '0px 1px 4px 0px #00000040',
      font: 'helvetica',
      textAlign: 'center',
      fontSize: '14px',
      fontWeight: 'bold',
      display: 'block',
    };
  }

  getDivHeight() {
    return {
      margin: '0 auto',
      display: 'table',
      marginBottom: '6px',
      marginTop: '6px',
    };
  }

  render() {
    return (
      <div className={'row col-md-12'}>
        <div className={'col-md-4'}>
          <span></span>
        </div>
        <div className={'col-md-8'}>
          <div className={'col-md-2'} style={this.getDivHeight()}>
            <span style={this.getHeaderStyle()}>Read</span>
          </div>
          <div className={'col-md-2'} style={this.getDivHeight()}>
            <span style={this.getHeaderStyle()}>Add</span>
          </div>
          <div className={'col-md-2'} style={this.getDivHeight()}>
            <span style={this.getHeaderStyle()}>Edit</span>
          </div>
          <div className={'col-md-2'} style={this.getDivHeight()}>
            <span style={this.getHeaderStyle()}>Delete</span>
          </div>
          <div className={'col-md-2'} style={this.getDivHeight()}>
            <span style={this.getHeaderStyle()}>Disable</span>
          </div>
          <div className={'col-md-2'} style={{height: '50px'}}>
            <span style={this.getHeaderStyle()}>Assign WKC</span>
          </div>
        </div>
      </div>
    );
  }
}

HeaderRow.defaultProps = {};

export default HeaderRow;
